function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count-bubble span").forEach((el) => {
    el.textContent = count;
  });
  document.querySelector(".cart-count-total").value = count;
}

function initializeSlickSlider() {
  // Destroy the existing Slick slider if it exists
  if ($('#product-grid-collection, #product-grid-product').hasClass('slick-initialized')) {
    $('#product-grid-collection, #product-grid-product').slick('unslick');
  }

  // Re-initialize the Slick slider
  $('#product-grid-collection, #product-grid-product').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    infinite: false,
    arrows: true,    
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;
  
  addCartDrawerListeners();
  addUpsellProduct();
  offer_progressbar();
  initializeSlickSlider();
  CheckoutButton();
}

function free_shipping(note_val) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json;",
    },
    body: JSON.stringify({
      attributes: {
        _free_shipping: note_val,
      },
    }),
  });
}

async function get_country_code() {
  var user_country = Cookies.get("acid_runnind_user_country");
  if (user_country == undefined) {
    return await fetch("/browsing_context_suggestions.json")
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        var user_country = data.detected_values.country.handle;
        // console.log(user_country)
        Cookies.set("acid_runnind_user_country", user_country, {
          expires: 7,
        });
        return user_country;
      });
  } else {
    return user_country;
  }
}

async function offer_progressbar() {
  const country_code = await get_country_code();
  console.log("country_code::",country_code,country_code.toLowerCase())

  if(country_code.toLowerCase() === 'uk' || country_code.toLowerCase() == 'gb'){
    document.querySelector(".cart-drawer-box .cart-shipping")?.classList.remove('hide');
    if(discount_thresold_1 != null && remaining_note != null ){
      fetch("/cart.js").then((response) => response.json()).then((cart) => {
        var cart_total = cart.total_price / 100;
        var result = (cart_total / discount_thresold_1) * 100;
        if (cart_total <= discount_thresold_1) {
          var away = discount_thresold_1 - cart_total;          
          let remainingNote = remaining_note.replaceAll("XXXX", `${currencySymbol}${away}`);        
          $(".offer-progressbar_txtop").text(remainingNote).parent().removeClass('done');
          if (result <= 100) {
            $(".offer-progressbar-inner").css("width", result + "%");
          }else{
            result = 100
            $(".offer-progressbar-inner").css("width", result + "%");
          }
          free_shipping("");
        } else {
          free_shipping("yes");
          let remainingNote = free_shipping_note;
          $(".offer-progressbar_txtop").text(remainingNote).parent().addClass('done');
          $(".offer-progressbar-inner").css("width", "100%");
        }
      });
    }
  }else{
    document.querySelector(".cart-drawer-box .cart-shipping")?.classList.add('hide');
  }
}

function addCartDrawerListeners() {
  // Update quantities
  document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
    button.addEventListener("click", async () => {
      // Get line item key
      const rootItem = button.parentElement.parentElement.parentElement.parentElement.parentElement;
      const key = rootItem.getAttribute("data-line-item-key");

      // Get new quantity
      const currentQuantity = Number(button.parentElement.querySelector("input").value);
      const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
      const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
      if(newQuantity < 0){
        newQuantity = 0;
      }
      button.parentElement.querySelector("input").value = newQuantity;

      // Ajax update\
      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
      });
      const cart = await res.json();
      
      updateCartItemCounts(cart.item_count);

      // Update cart
      updateCartDrawer();        
      offer_progressbar();
      CheckoutButton();
    });
  });

  document.querySelectorAll(".cart-drawer-quantity-selector input").forEach((input) => {
    input.addEventListener("change", async () => {
      
      console.log("THIS INput", input.value)
      // Get line item key
      const inputRootItem = input.parentElement.parentElement.parentElement.parentElement.parentElement;
      const inputKey = inputRootItem.getAttribute("data-line-item-key");

      // Get new quantity
      const inputCurrentQuantity = Number(input.value);
      const inputNewQuantity = inputCurrentQuantity;

      // Ajax update\
      const inputRes = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [inputKey]: inputNewQuantity } }),
      });
      const inputCart = await inputRes.json();
      setTimeout( ()=> {
        updateCartItemCounts(inputCart.item_count);

        // Update cart
         updateCartDrawer();
        offer_progressbar();
        CheckoutButton();
      },150)
    });
  });  

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });
  
  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer-overlay").forEach((el) => {
    el.addEventListener("click", () => {
      console.log("closing drawer");
      closeCartDrawer();
    });
  });
}

document.addEventListener('DOMContentLoaded', function(evt){
  addCartDrawerListeners();
  offer_progressbar();
  addUpsellProduct();
  initializeSlickSlider();
  CheckoutButton();
  
  document.querySelector(".cart-drawer-overlay").addEventListener("click", (e) => {
    console.log("Close Click",document.querySelector(".cart-drawer-overlay"))
    closeCartDrawer();
  });
});

function CheckoutButton(){
  if(document.querySelector('.button-holder')){
    document.querySelector('.button-holder').addEventListener("click", (e) => {
      console.log("Click Checkout")
      const formSubmitButton = document.querySelector(".cart-drawer-box form .cart-checkout-btn.hide");
      formSubmitButton.click();
    });
  }
}
function addUpsellProduct(){
  // console.log("addUpsellProduct");
  document.querySelectorAll('.add-to-cart-btn.upsell-items-atc-btn').forEach(button => {
    button.addEventListener("click", function(e){
      e.preventDefault();
      
      const card = this.closest('.upsell-card');
      const variantId = card.querySelector('.upsell-items-variant-select').value;
      button.classList.add('loading');
      // console.log("DATA::",card,variantId)
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(cart => {        
        const cartCount = Number(document.querySelector('.cart-count-total').value) + 1;
        updateCartItemCounts(cartCount);
  
        // Update cart
        updateCartDrawer();        
        offer_progressbar();
        CheckoutButton();

        button.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    });
  }); 
}

document.querySelectorAll('a.cart-drawer-btn.header__icon').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});